import { Fragment } from "react";

import clsx from "clsx";

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { type SegmentOperator } from "@north-beam/nb-common";

const OPERATOR_LABEL = {
  and: "AND",
  or: "OR",
};

interface Props {
  value: SegmentOperator;
  onChange: (value: SegmentOperator) => void;
}

export const SegmentOperatorSelector = ({ value, onChange }: Props) => {
  return (
    <Menu as="div" className="h-8 flex items-center">
      {({ open }) => (
        <>
          <MenuButton
            as="button"
            className={clsx("block text-xs font-bold px-2 h-6 rounded", {
              "text-cosmic bg-cosmic-4 hover:bg-cosmic-3": !open,
              "text-white bg-cosmic": open,
            })}
          >
            {OPERATOR_LABEL[value]}
          </MenuButton>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <MenuItems
              anchor={{ to: "bottom start", gap: 8 }}
              className={clsx(
                "z-[2010] w-[140px] pt-1 pb-2 origin-top-right",
                "rounded-[8px] bg-white elevation-1",
              )}
            >
              {(["or", "and"] as const).map((operator) => {
                return (
                  <MenuItem key={operator}>
                    {({ focus }) => (
                      <div
                        className={clsx(
                          "text-xs px-4 w-full h-8",
                          "flex items-center cursor-pointer whitespace-nowrap",
                          {
                            "font-bold bg-cosmic-4": value === operator,
                            "bg-cosmic-4": focus,
                          },
                        )}
                        onClick={() => {
                          onChange(operator);
                        }}
                      >
                        {OPERATOR_LABEL[operator]}
                      </div>
                    )}
                  </MenuItem>
                );
              })}
            </MenuItems>
          </Transition>
        </>
      )}
    </Menu>
  );
};
